import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { putGroupSignUp4 } from "../../api/signin";
import { updateInfo } from "../../api/user";
import DescriptionIcon from "../../assets/SVG/descriptionIcon";
import InputLoginForm from "../login/inputLoginForm";
import ButtonNextLevel from "./buttonNextLevel";
import ChekboxListBranch, { CheckBoxBranch } from "./chekboxListBranch";

export default function SigninBranch({
  level,
  setLevel,
  dataForm,
  setDataForm,
  update,
}) {
  const [Arr, setArr] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    setDataForm({ ...dataForm, medicalExpertises: Arr });
  }, [Arr]);
  useEffect(() => {
    if (dataForm?.medicalExpertises?.length > 0) {
      setArr(dataForm?.medicalExpertises);
    }
  }, [dataForm?.medicalExpertises]);
  return (
    <>
      <Typography color="#126E83" fontSize="20px">
        {"بخش‌ها"}
      </Typography>
      <Typography mt="20px" fontSize="20px" color="#5E5E5E">
        {
          "در صورت حضور بخش‌های زیر در گروه جهادی‌تان، خواهشمندیم به سوالات مطروحه پاسخ کامل دهید؛ در غیر این صورت، فیلدها را خالی رها کنید."
        }
      </Typography>
      <Box mb="50px" mt="20px" display={"flex"} gap="100px" width="100%">
        <Box width="70%">
          <InputLoginForm
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                screeningSicknesses: [e.target.value],
              })
            }
            value={update ? dataForm?.screeningSicknesses[0] : ""}
            lable={"غربالگری بیماری های شایع دارید؟"}
            placeholder="بیماری هایی را که غربال می کنید نام ببرید."
          >
            <DescriptionIcon />
          </InputLoginForm>
          <InputLoginForm
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                donateMedicine: e.target.value.replace(/\D/g, ""),
              })
            }
            value={dataForm.donateMedicine}
            mt="20px"
            lable={"اهدای رایگان دارو دارید؟"}
            placeholder="به طور متوسط چند قلم دارو همراه دارید؟."
          >
            <DescriptionIcon />
          </InputLoginForm>
        </Box>
        <Box width="100%">
          <InputLoginForm
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                publicDoctors: e.target.value.replace(/\D/g, ""),
              })
            }
            value={dataForm.publicDoctors}
            lable={"پزشک عمومی دارید؟"}
            placeholder="تعداد پزشک‌های عمومی تیم را وارد کنید.."
          >
            <DescriptionIcon />
          </InputLoginForm>
        </Box>
      </Box>
      <Typography color="#126E83" fontSize="20px">
        {"بخش‌ها"}
      </Typography>
      <Typography mt="20px" fontSize="20px" color="#5E5E5E">
        {
          "در صورت حضور بخش‌های زیر در گروه جهادی‌تان، آن موارد را علامت بزنید. در غیر این صورت، آن را خالی رها کنید."
        }
      </Typography>
      <ChekboxListBranch
        update={update}
        dataForm={dataForm}
        setDataForm={setDataForm}
      />
      <Typography color="#126E83" mt="30px" fontSize="20px">
        {"بخش‌ها"}
      </Typography>
      <Typography mt="20px" fontSize="20px" color="#5E5E5E">
        {
          "در صورتی که گروه جهادی تان در حوزه های پزشکی زیر تخصص دارد آن موارد را علامت بزنید. در غیر این صورت آن را خالی رها کنید."
        }
      </Typography>

      <Box mt="20px" display="flex" flexWrap="wrap">
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "INNER"]);
            } else {
              setArr(Arr.filter((item) => item !== "INNER"));
            }
          }}
          checked={Arr?.includes("INNER")}
          label="داخلی"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "INFANT"]);
            } else {
              setArr(Arr.filter((item) => item !== "INFANT"));
            }
          }}
          label="اطفال"
          checked={Arr?.includes("INFANT")}
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "EAR"]);
            } else {
              setArr(Arr.filter((item) => item !== "EAR"));
            }
          }}
          checked={Arr?.includes("EAR")}
          label="گوش و حلق و بینی"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "ORTHOPEDICS"]);
            } else {
              setArr(Arr.filter((item) => item !== "ORTHOPEDICS"));
            }
          }}
          checked={Arr?.includes("ORTHOPEDICS")}
          label="ارتوپدی"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "UROLOGY"]);
            } else {
              setArr(Arr.filter((item) => item !== "UROLOGY"));
            }
          }}
          checked={Arr?.includes("UROLOGY")}
          label="ارولوژی"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "RADIOLOGY"]);
            } else {
              setArr(Arr.filter((item) => item !== "RADIOLOGY"));
            }
          }}
          checked={Arr?.includes("RADIOLOGY")}
          label="رادیولوژی"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "SKIN"]);
            } else {
              setArr(Arr.filter((item) => item !== "SKIN"));
            }
          }}
          checked={Arr?.includes("SKIN")}
          label="پوست"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "NERVES"]);
            } else {
              setArr(Arr.filter((item) => item !== "NERVES"));
            }
          }}
          checked={Arr?.includes("NERVES")}
          label="اعصاب"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "WIFE"]);
            } else {
              setArr(Arr.filter((item) => item !== "WIFE"));
            }
          }}
          checked={Arr?.includes("WIFE")}
          label="زنان"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "EYE"]);
            } else {
              setArr(Arr.filter((item) => item !== "EYE"));
            }
          }}
          checked={Arr?.includes("EYE")}
          label="چشم"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "SURGERY"]);
            } else {
              setArr(Arr.filter((item) => item !== "SURGERY"));
            }
          }}
          checked={Arr?.includes("SURGERY")}
          label="جراحی"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "INFECTION"]);
            } else {
              setArr(Arr.filter((item) => item !== "INFECTION"));
            }
          }}
          checked={Arr?.includes("INFECTION")}
          label="عفونی"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "PSYCHIATRY"]);
            } else {
              setArr(Arr.filter((item) => item !== "PSYCHIATRY"));
            }
          }}
          checked={Arr?.includes("PSYCHIATRY")}
          label="روانپزشکی"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "PHYSICAL"]);
            } else {
              setArr(Arr.filter((item) => item !== "PHYSICAL"));
            }
          }}
          checked={Arr?.includes("PHYSICAL")}
          label="فیزیکی"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "PHYSICAL_MEDICINE"]);
            } else {
              setArr(Arr.filter((item) => item !== "PHYSICAL_MEDICINE"));
            }
          }}
          checked={Arr?.includes("PHYSICAL_MEDICINE")}
          label="طب فیزیکی"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "SOCIAL_MEDICINE"]);
            } else {
              setArr(Arr.filter((item) => item !== "SOCIAL_MEDICINE"));
            }
          }}
          checked={Arr?.includes("SOCIAL_MEDICINE")}
          label="پزشکی اجتماعی و بهداشت"
        />
        <CheckBoxBranch
          onChange={(e) => {
            if (e.target.checked === true) {
              setArr([...Arr, "SPORT_MEDICINE"]);
            } else {
              setArr(Arr.filter((item) => item !== "SPORT_MEDICINE"));
            }
          }}
          checked={Arr?.includes("SPORT_MEDICINE ")}
          label="طب ورزشی"
        />
      </Box>
      <Box width="90%" my="20px">
        <ButtonNextLevel
          onClickNextLevel={() => {
            if (update) {
              updateInfo(dataForm)
                .then(() => {
                  navigate("/");
                })
                .catch(() => {});
            } else {
              putGroupSignUp4(dataForm)
                .then(() => {
                  setLevel(5);
                })
                .catch((err) => {
                  // toast.error(err.data)
                });
            }
          }}
          setLevel={setLevel}
          level={level}
          justifyContent="end"
        />
      </Box>
    </>
  );
}
